import ClearImageUpload from './ClearImageUpload';

export default ClearImageUpload;
